import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import NotificationBellIcon from "./NotificationBellIcon";
import { useNotificationContext } from "../../contexts/NotificationContext";
import { useProfile } from "@brg/auth";
import NotificationList from "./NotificationList";
import { useModal } from "../../../core";
import { AppTester } from "supporting";
import { useTranslation } from "react-i18next";
import { NotificationListContainer, Wrapper } from "./styles";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import { useDispatch } from "react-redux";
import { createPortal } from "react-dom";

const NotificationsController: FC = () => {
  const { unreadCount, notifications, connection, readLocally, readNotification, setOpen, open, scroll, popupHeight } = useNotificationContext();
  const profile = useProfile();
  const modal = useModal();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();
  
  const isMobile = useBreakpoint(568);
  const is1200 = useBreakpoint(1200)

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

  const combinedStyle = { ...baseStyle, ...geoStyle };

  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const bellIconRef = useRef<HTMLDivElement | null>(null);
  const [scrollPosition, setScrollPosition] = useState(0);

    const onTargetClick = useCallback(() => {
      setScrollPosition(window.scrollY);
      if(open){
        setOpen(false);
      }else{
        setOpen(true);
      }
     
      dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }))
    }, [notifications, open]);

    useEffect(() => {
      if (!open) {
        window.scrollTo(0, scrollPosition);
      }
    }, [open]);
  
    const handleClickOutside = useCallback((event: MouseEvent) => {
      if (bellIconRef.current?.contains(event.target as Node)) {
        return
      }

      if (wrapperRef.current && !wrapperRef.current?.contains(event.target as Node)) {
        setOpen(false);
        const dropdownElement = wrapperRef.current?.querySelector('.dropdown-element-popup');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }, []);

    const Portal = useMemo(() => {
      const outer = document.getElementById('navbar-portal');
  
      if (!outer || !open) {
        return null;
      }
  
      return createPortal(
        <NotificationListContainer ref={wrapperRef}>
          <NotificationList/>
        </NotificationListContainer>,
        outer,
      );
} , [popupHeight, connection, notifications, scroll, open, wrapperRef, unreadCount, combinedStyle])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  //костыль, но работает, по возможности найти решение получше
  useEffect(() => {
    setOpen(false)
  }, [is1200, isMobile])

  if (!profile || !connection) {
    return null;
  }

  const handleClick = () => {
    modal.show('notifications');
  }

  if (isMobile) {
    return (
      <FlexBox onClick={handleClick} offsetRight={11}>
        <NotificationBellIcon unreadCount={unreadCount}/>
      </FlexBox>
    )
  }

  return (
    <Wrapper onClick={onTargetClick}>
      {Portal}
    <HintTooltip 
// @ts-ignore
      customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t("hints.notifications")}>
      <NotificationBellIcon iconRef={bellIconRef} unreadCount={unreadCount}/>
    </HintTooltip>
  </Wrapper>
  );
}

export default NotificationsController;import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FlexBox, HintTooltip, useBreakpoint } from "@brg/ui";
import NotificationBellIcon from "./NotificationBellIcon";
import { useNotificationContext } from "../../contexts/NotificationContext";
import { useProfile } from "@brg/auth";
import NotificationList from "./NotificationList";
import { useModal } from "../../../core";
import { AppTester } from "supporting";
import { useTranslation } from "react-i18next";
import { NotificationListContainer, Wrapper } from "./styles";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import { useDispatch } from "react-redux";
import { createPortal } from "react-dom";

const NotificationsController: FC = () => {
  const { unreadCount, notifications, connection, readLocally, readNotification, setOpen, open, scroll, popupHeight } = useNotificationContext();
  const profile = useProfile();
  const modal = useModal();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isCGRAVE = AppTester.isCGRAVE();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();
  
  const isMobile = useBreakpoint(568);
  const is1200 = useBreakpoint(1200)

  const baseStyle = { padding: '2px 8px 4px' };
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

  const combinedStyle = { ...baseStyle, ...geoStyle };

  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const bellIconRef = useRef<HTMLDivElement | null>(null);
  const [scrollPosition, setScrollPosition] = useState(0);

    const onTargetClick = useCallback(() => {
      setScrollPosition(window.scrollY);
      if(open){
        setOpen(false);
      }else{
        setOpen(true);
      }
     
      dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }))
    }, [notifications, open]);

    useEffect(() => {
      if (!open) {
        window.scrollTo(0, scrollPosition);
      }
    }, [open]);
  
    const handleClickOutside = useCallback((event: MouseEvent) => {
      if (bellIconRef.current?.contains(event.target as Node)) {
        return
      }

      if (wrapperRef.current && !wrapperRef.current?.contains(event.target as Node)) {
        setOpen(false);
        const dropdownElement = wrapperRef.current?.querySelector('.dropdown-element-popup');
        if (dropdownElement) {
          dropdownElement.classList.remove('show');
        }
      }
    }, []);

    const Portal = useMemo(() => {
      const outer = document.getElementById('navbar-portal');
  
      if (!outer || !open) {
        return null;
      }
  
      return createPortal(
        <NotificationListContainer ref={wrapperRef}>
          <NotificationList/>
        </NotificationListContainer>,
        outer,
      );
} , [popupHeight, connection, notifications, scroll, open, wrapperRef, unreadCount, combinedStyle])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  //костыль, но работает, по возможности найти решение получше
  useEffect(() => {
    setOpen(false)
  }, [is1200, isMobile])

  if (!profile || !connection) {
    return null;
  }

  const handleClick = () => {
    modal.show('notifications');
  }

  if (isMobile) {
    return (
      <FlexBox onClick={handleClick} offsetRight={11}>
        <NotificationBellIcon unreadCount={unreadCount}/>
      </FlexBox>
    )
  }

  return (
    <Wrapper onClick={onTargetClick}>
      {Portal}
    <HintTooltip 
// @ts-ignore
      customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t("hints.notifications")}>
      <NotificationBellIcon iconRef={bellIconRef} unreadCount={unreadCount}/>
    </HintTooltip>
  </Wrapper>
  );
}

export default NotificationsController;